import { Backdrop, CircularProgress } from '@mui/material'

type Props = {
  open: boolean
}

const GlobalPageLoader = ({ open }: Props) => {
  return (
    <Backdrop open={open} sx={{ zIndex: '1500!important' }}>
      <CircularProgress color="primary" />
    </Backdrop>
  )
}

export default GlobalPageLoader
